import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('product-features/list', { params });
  },
  async add(params: any) {
    return axios.post('product-features/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('product-features/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('product-features/detail', { params });
  },
  async delete(params: any) {
    return axios.post('product-features/delete', qs.stringify(params));
  },
};
